import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { CodigosBackBeneficiosReforma, TiposTextosImportanteReformaPensiones } from '@constants/reforma-pensiones.constants';
import { ROUTING_CAMBIO_VIA_PAGO_PENSION } from '@constants/url.constant';

@Component({
  selector: 'app-card-importante',
  standalone: false,
  templateUrl: './card-importante.component.html',
  styleUrl: './card-importante.component.scss'
})
export class CardImportanteComponent {
  @Input() tipo: TiposTextosImportanteReformaPensiones;
  @Input() urlCapitalPlay?: string;
  @Input() codigosBackBeneficiosOtorgados: string[] = [];

  public tipoBeneficios = TiposTextosImportanteReformaPensiones.PaginaBeneficiosReforma;
  public tipoDetalleBeneficios = TiposTextosImportanteReformaPensiones.PaginaDetalleBeneficiosReforma;

  constructor(private readonly router: Router) { }

  get mostrarTextoMontoUF(): boolean {
    return this.codigosBackBeneficiosOtorgados.some(b => b === CodigosBackBeneficiosReforma.BAC || b === CodigosBackBeneficiosReforma.CEV);
  }

  get mostrarComoLista(): boolean {
    return this.mostrarTextoMontoUF;
  }

  irViaDePago() {
    this.router.navigate([
      ROUTING_CAMBIO_VIA_PAGO_PENSION.CAMBIO_VIA_BASE,
      ROUTING_CAMBIO_VIA_PAGO_PENSION.CAMBIO_VIA_PAGO_URL,
      ROUTING_CAMBIO_VIA_PAGO_PENSION.CAMBIO_VIA_PAGO_HOME
    ]);
  }

  irCapitalPlay() {
    window.open(this.urlCapitalPlay, '_blank');
  }
}